<template>
  <v-row v-if="hasRetentionLeads" no-gutters class="mt-4 mb-3">
    <v-col>
      <v-sheet dark rounded height="60" color="tertiary" class="d-flex align-center justify-space-between">
        <div class="body-1">
          <div style="border: 2px solid white;" class="pa-2 mx-5 rounded-circle d-inline-block">
            <v-icon>{{mdiGavel}}</v-icon>
          </div>
          This product is part of an open retention lead: {{ getRetentionProducts[0].id }}
        </div>
        <v-icon large class="mx-5" @click="openRetentionLead(getRetentionProducts[0].id)">{{mdiOpenInNew}}</v-icon>
      </v-sheet>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { mdiGavel, mdiOpenInNew } from '@mdi/js';

export default {
  props: ["productId"],

  data() {
    return {
      mdiGavel,
      mdiOpenInNew,
      status: ["Open", "New"]
    }
  },

  computed: {
    ...mapGetters("products", ["getRetentionProducts", "getRetentionProductsLoading"]),

    hasRetentionLeads() {
      return !!this.getRetentionProducts.length;
    }
  },

  methods: {
    ...mapActions("products", ["fetchRetentionProducts"]),

    openRetentionLead(id) {
      let routeData = this.$router.resolve({ name: 'retentionleadview', params: { id: id } });
      window.open(routeData.href, '_blank');
    }
  },

  mounted() {
    this.fetchRetentionProducts({ productId: this.productId, status: this.status });
  }
}
</script>

<style>

</style>